'use client'

import { Dialog } from '@vinted/web-ui'

import {
  markAsDeliveredToSender,
  clickEvent,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { reloadPage } from '@marketplace-web/shared/browser-util'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

type Props = {
  transactionId: number
  isOpen: boolean
  onClose: () => void
  screen: string
}

const MarkAsDeliveredToSenderConfirmationModal = ({
  transactionId,
  isOpen,
  onClose,
  screen,
}: Props) => {
  const translate = useTranslate('conversation.tracking_details.mark_as_delivered_to_sender')
  const { track } = useTracking()

  function trackMarkAsDeliveredClick() {
    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        screen,
        target: 'mark_as_received',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  async function handleMarkAsDeliveredClick() {
    trackMarkAsDeliveredClick()
    await markAsDeliveredToSender(transactionId)
    onClose()
    reloadPage()
  }

  return (
    <Dialog
      show={isOpen}
      defaultCallback={onClose}
      title={translate('title')}
      body={translate('body')}
      actions={[
        {
          text: translate('confirm'),
          callback: handleMarkAsDeliveredClick,
          style: Dialog.ActionStyling.Filled,
        },
        {
          text: translate('close'),
          callback: onClose,
          style: Dialog.ActionStyling.Flat,
        },
      ]}
    />
  )
}

export default MarkAsDeliveredToSenderConfirmationModal
